import React from 'react';
import PropTypes from 'prop-types';
import { CancelButton } from './styles';

export const BrightbackCancelButton = ({
  handleBrightbackCancelClick,
  cancelButtonLabel,
}) => (
  <CancelButton role="button" onClick={handleBrightbackCancelClick}>
    {cancelButtonLabel}
  </CancelButton>
);

BrightbackCancelButton.displayName = 'BrightbackCancelButton';
BrightbackCancelButton.propTypes = {
  handleBrightbackCancelClick: PropTypes.func.isRequired,
  cancelButtonLabel: PropTypes.string.isRequired,
};
